export const unwrapDeviceId = (
    constraint: ConstrainDOMString | undefined,
): string | undefined => {
    if (!constraint) return undefined;
    if (typeof constraint === 'string') return constraint;
    if (Array.isArray(constraint)) return constraint[0];
    return (constraint as {exact?: string; ideal?: string}).exact
        || (constraint as {exact?: string; ideal?: string}).ideal
        || undefined;
};

/**
 * Returns savedId if it is present in the device list, otherwise falls back
 * to the first device of the given kind (system default).
 */
export const resolveDeviceId = (
    savedId: string | undefined,
    devices: MediaDeviceInfo[],
    kind: MediaDeviceKind,
): string | undefined => {
    const firstOfKind = devices.find(d => d.kind === kind)?.deviceId;
    if (!savedId) return firstOfKind;
    return devices.some(d => d.kind === kind && d.deviceId === savedId)
        ? savedId
        : firstOfKind;
};
